import { render, staticRenderFns } from "./LoadingSpinnerBlack.vue?vue&type=template&id=52b7ad2a&"
import script from "./LoadingSpinnerBlack.vue?vue&type=script&lang=js&"
export * from "./LoadingSpinnerBlack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports